import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import GuideLayout from './GuideLayout';

// 2026-07-14 — Route dinamica /guide/:slug (+ /:lang/guide/:slug).
// Le guide vivono in WP (CPT guide, REST base /wp-json/wp/v2/guides,
// Polylang: slug UNIVOCO per lingua → il fetch by-slug basta, niente
// parametro lang). Prima di questa route la SPA conosceva SOLO i 5 slug
// hardcoded di maggio e il catch-all * rimandava in home: le 15 guide
// nuove (manuale/onboarding/primi-passi × 5 lingue) erano irraggiungibili
// qualunque rebuild si facesse.
const WP_LANGS = ['en', 'es', 'fr', 'de']; // IT = default, senza prefisso

const decodeEntities = (s) => {
  const el = document.createElement('textarea');
  el.innerHTML = s || '';
  return el.value;
};

const GuideWpPage = () => {
  const { slug, lang } = useParams();
  const [state, setState] = useState({ status: 'loading', guide: null });

  useEffect(() => {
    let alive = true;
    setState({ status: 'loading', guide: null });
    fetch(`/wp-json/wp/v2/guides?slug=${encodeURIComponent(slug)}&_fields=id,slug,title,content,modified`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('http ' + r.status))))
      .then((rows) => {
        if (!alive) return;
        if (Array.isArray(rows) && rows.length > 0) {
          setState({ status: 'ok', guide: rows[0] });
        } else {
          setState({ status: 'notfound', guide: null });
        }
      })
      .catch(() => { if (alive) setState({ status: 'notfound', guide: null }); });
    return () => { alive = false; };
  }, [slug]);

  if (lang && !WP_LANGS.includes(lang)) return <Navigate to="/guide" replace />;
  if (state.status === 'notfound') return <Navigate to="/guide" replace />;

  if (state.status === 'loading') {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#0055FF] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  const g = state.guide;
  const title = decodeEntities(g.title && g.title.rendered);
  const updated = g.modified ? new Date(g.modified).toLocaleDateString() : null;

  return (
    <GuideLayout title={title} lastUpdated={updated}>
      <div dangerouslySetInnerHTML={{ __html: (g.content && g.content.rendered) || '' }} />
    </GuideLayout>
  );
};

export default GuideWpPage;
